import {
  GET_REFERRALS,
  GET_ROLES,
  GET_SATCONTENT,
  GET_SATCONTENTACTION,
  GET_NOTIFICATIONS,
  GET_NOTIFICATIONSACTION,
  GET_FOOTER,
  GET_CONTENT

} from "./mutation-types";
import { dataService } from "../services/data.service";

const state = () => ({
  referrals: [],
  roles: [],
  satContent: {},
  notifications: {},
  footerNav:[],
  content: {},
});

const mutations = {
  [GET_REFERRALS](state, referrals) {
    state.referrals.push(referrals);
  },
  [GET_ROLES](state, roles) {
    state.roles.push(roles);
  },
  [GET_SATCONTENT](state, satContent) {
    state.satContent = satContent;
  },

  [GET_NOTIFICATIONS](state, notifications) {
    state.notifications = notifications;
  },
  [GET_FOOTER](state, footerNav) {
    state.footerNav.push(footerNav);
  },
  [GET_CONTENT](state, content) {
    state.content = content;
  },
};

const actions = {
  async getReferrals({ commit }) {
    //const referrals = await dataService.getReferrals();
    const result = await dataService.getToolsContent(); 
    if (result && result.HowDidYouHearAboutUs){
      var referrals = result.HowDidYouHearAboutUs.map((ref) =>{
        return { value: ref};
      });
      commit(GET_REFERRALS, referrals);
      return referrals;
    } 
  },

  async getRoles({ commit }) {
    //const roles = await dataService.getRoles();
    const result = await dataService.getToolsContent(); 
    if (result && result.Roles) {
      var roles = result.Roles.map((role) =>{
        return { value: role};
      });

      commit(GET_ROLES, roles);
      return roles;
    }
  },
  async [GET_SATCONTENTACTION]({ commit }) {
    const satContent = await dataService.getSatContent();
    commit(GET_SATCONTENT, satContent);
  },

  async [GET_NOTIFICATIONSACTION]({ commit }) {
    const notifications = await dataService.getNotificationsData();
    commit(GET_NOTIFICATIONS, notifications);
  },
  async getContent({ commit }) {
    const content = await dataService.getContent();
    commit(GET_CONTENT, content);
  },
  async getFooterNav({ commit }) {
    const result = await dataService.getFooterNav();
    // if(result && result.Items){
    //   var footer = result.Items.map((x) =>{
    //     return { pageName: x.PageName,
    //     url:x.PageUrl};
    //   });
    commit(GET_FOOTER, result);
    return result;
    
  }
};

const getters = {
  getReferrals: state => state.satContent.HowDidYouHearAboutUs,
  getRoles: state => state.satContent.Roles
};

export const util = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
